import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';

import SelectInput from '@core/components/selectInput/SelectInput';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import classes from './LanguageSelector.module.scss';

const LanguageSelector = ({ metadata = {}, index, data, languagesChangeHandler, horizontal = true }) => {
	const [textValue, setTextValue] = useState('');
	const {
		setValue,
		control,
		formState: { errors, isDirty, isValid },
		watch
	} = useForm({
		mode: 'onChange',
		defaultValues: {
			language_iso: data?.language_iso || '',
			proficiency: data?.proficiency || ''
		}
	});
	const values = watch();
	useEffect(() => {
		languagesChangeHandler({ ...values, formId: index }, index);
	}, [JSON.stringify(values)]);
	return (
		<div className={`row ${classes['language-selector-container']} d-flex align-items-center`}>
			<div className={`d-flex ${horizontal ? 'flex-column' : 'flex-row'} gap-3`}>
				<div>
					<label htmlFor={`language-${index}`}>Language</label>
					<Autocomplete
						options={metadata.languages}
						getOptionLabel={(option) => {
							return option.name;
						}}
						onChange={(e, newValue) => setValue('language_iso', newValue?.iso)}
						disablePortal
						className={`${!values?.language_iso && !textValue && classes['placeholder']}`}
						style={{ '--custom-content': `Language` }}
						id={`language-${index}`}
						defaultValue={
							values ? metadata.languages.find((lng) => lng.iso === values?.language_iso) : ''
						}
						isOptionEqualToValue={(option, value) => {
							return option.iso === value.iso;
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								id={`language-${index}`}
								variant="outlined"
								onChange={(e) => {
									setTextValue(e.target.value);
								}}
							/>
						)}
					/>
					{/* <SelectInput
						input={{
							label: 'Language',
							name: 'language',
							id: `language-${index}`
						}}
						errors={errors}
						control={control}
						options={metadata.languages}
						optionsNameKey="name"
						optionsIdKey="iso"
						placeholder="Language"
					/> */}
				</div>
				<div>
					<SelectInput
						input={{
							label: 'Level',
							name: 'proficiency',
							id: `proficiency-${index}`
						}}
						errors={errors}
						control={control}
						options={metadata.language_proficiencies}
						optionsNameKey="proficiency"
						placeholder="Proficiency"
						defaultValue={data ? data?.proficiency : ''}
					/>
				</div>
			</div>
		</div>
	);
};

export default LanguageSelector;
